const instances = {
    "NDCS_SC": {
        name: 'NDCS_SC',
        domain:"make.dainsta.com"
    },
    '8XPARTS_SC': {
        name: '8XPARTS_SC',
        domain:"make.8xparts.com"
    },
    "PIPL_SC":{
        name:'PIPL_SC',
        domain:'make.precilayer.com',
    }
};

export const allInstanceData = {
    '_8xP': '8XPARTS_SC',
    'NDCS': 'NDCS_SC',
    'PIPL': 'PIPL_SC'
};


const currentInstance = process.env.REACT_APP_INSTANCE_NAME || 'NDCS_SC';

export const config = instances[currentInstance];